import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthService } from 'src/app/auth.service';
import { FirebaseService } from 'src/app/services/firebase.service';

declare const bootstrap: any;

@Component({
  selector: 'app-ticket-system',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './ticket-system.component.html',
  styleUrl: './ticket-system.component.css',
})
export class TicketSystemComponent implements OnInit {
  selectedPage = '';
  description = '';
  imageFile: File | null = null;
  pages: string[] = [];
  toastMessage = '';
  toastType: 'success' | 'error' = 'success';
  showToast = false;

  constructor(private auth: AuthService, private firebase: FirebaseService) {}

  async ngOnInit() {
    const role = await this.getUserRole();
    this.setPagesByRole(role);
  }

  private async getUserRole(): Promise<'admin' | 'manager' | 'user'> {
    try {
      const user = await this.auth.getUser?.();
      if (!user) return 'user';
      const role = user.role?.toLowerCase?.() || 'user';
      if (role.includes('admin')) return 'admin';
      if (role.includes('manager')) return 'manager';
      return 'user';
    } catch {
      return 'user';
    }
  }

  private setPagesByRole(role: 'admin' | 'manager' | 'user') {
    const base = ['Login Page', 'Schedule', 'Request Off', 'Settings', 'Other'];
    const manager = ['Manager', 'Schedule Builder'];
    const admin = ['Admin Panel'];

    this.pages =
      role === 'admin'
        ? [...base, ...manager, ...admin]
        : role === 'manager'
        ? [...base, ...manager]
        : base;
  }

  onFileSelected(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0] || null;
    this.imageFile = file;
  }

  async submitTicket() {
    if (!this.selectedPage || !this.description.trim()) {
      this.openModal('errorModal');
      return;
    }

    try {
      // Build ticket object
      const user = await this.auth.getUser?.();
      const ticketData = {
        page: this.selectedPage,
        description: this.description.trim(),
        submittedAt: new Date().toISOString(),
        submittedBy: user?.Name || 'Anonymous',
        userId: user?.id || null,
      };

      // Upload to Firestore (and Storage if imageFile exists)
      await this.firebase.createSupportTicket(
        ticketData,
        this.imageFile || undefined
      );

      this.openModal('successModal');
      this.resetForm();
    } catch (err) {
      console.error('❌ Ticket submission failed:', err);
      this.toastType = 'error';
      this.toastMessage = 'Something went wrong. Please try again.';
      this.showToast = true;
    }
  }

  private resetForm() {
    this.selectedPage = '';
    this.description = '';
    this.imageFile = null;
    const fileInput = document.getElementById('ticketFile') as HTMLInputElement;
    if (fileInput) fileInput.value = '';
  }

  openModal(id: string) {
    const el = document.getElementById(id);
    if (el) {
      const modal = new bootstrap.Modal(el);
      modal.show();
    }
  }

  closeModal(id: string) {
    const el = document.getElementById(id);
    if (!el) return;
    const instance = bootstrap.Modal.getInstance(el);
    instance?.hide();
  }
}
